import { coreApi } from '@cp/shared/api/core';
import { TariffViewModel } from '@common/model/billing/tariff/view';
import { ApiTags } from '@cp/shared/api/core/const';
import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { BillingTariffsRequest } from '@common/model/billing/tariff/list.request';
import { ApiRoutePathParams } from '@common/api/routePathParams';

export const billingTariffApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getBillingTariffs: builder.query<TariffViewModel[], BillingTariffsRequest | void>({
      query: (params) => ({
        url: generateApiUrl(ApiRoute.BillingTariffs),
        method: apiRouteMethodDict[ApiRoute.BillingTariffs],
        params,
      }),
      providesTags: [ApiTags.BillingTariffList],
    }),
    getBillingTariff: builder.query<TariffViewModel, ApiRoutePathParams[ApiRoute.BillingTariffsGetOne]>({
      query: (params) => ({
        url: generateApiUrl(ApiRoute.BillingTariffsGetOne, params),
        method: apiRouteMethodDict[ApiRoute.BillingTariffsGetOne],
        params,
      }),
      providesTags: (response, error, params) => [{ type: ApiTags.BillingTariffList, id: params.id }],
    }),
  }),
});
